export default __webpack_public_path__ + "static/media/logo2.b7f69f65.png";